export default __webpack_public_path__ + "static/media/Bb4.54bb6bae.mp3";